import { render, staticRenderFns } from "./postalPopup.vue?vue&type=template&id=712af595&"
import script from "./postalPopup.vue?vue&type=script&lang=js&"
export * from "./postalPopup.vue?vue&type=script&lang=js&"
import style0 from "./postalPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports